<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item">
          <a href="/service-location">Service Location Form</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Service Location Form
        </li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>Service Location Form</h3>
      </div>
    </div>
    <form>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Desktop</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.desktop_thumbnail_url != ''" :src="form.desktop_thumbnail_url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail desktop</label>
            <searchbox @searchButtonClick="seachDesktopThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="desktop_thumbnail" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageDesktopThumbnail">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">Thumbnail Mobile</h3>
        </div>
      </div>
      <div class="row border">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ตัวอย่างภาพ</label>
            <img v-if="form.mobile_thumbnail_url != ''" :src="form.mobile_thumbnail_url" alt=""
              class="img-thumbnail" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ thumbnail mobile</label>
            <searchbox @searchButtonClick="seachMobileThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image :dataImages="mobile_thumbnail" :useLabel="true" :w="'80px'" :limit="41"
                  @onselectimage="onSelectImageMobileThumbnail">
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a id="post_add_thumbnail" href="/media/form" target="_blank"
              class="btn btn-secondary form-control">เพิ่มภาพใหม่</a>
          </div>
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-md-12">
          <h3 class="text text-secondary">ข้อมูลทั่วไป</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="post_status">สถานะ *</label>
            <select class="form-control" v-model="form.status">
              <option></option>
              <option :value="'published'">published</option>
              <option :value="'draft'">draft</option>
              <option :value="'disabled'">disabled</option>
              <option :value="'trash'">trash</option>
            </select>
            <span v-if="errors['status']" class="text-danger">{{ errors['status'][0] }}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_slug required">slug *</label>
            <input type="text" class="form-control" v-model="form.slug" />
            <span v-if="errors['slug']" class="text-danger">{{ errors['slug'][0] }}</span>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="post_type required">ชนิด *</label>
            <select class="form-control" aria-describedby="post_type_Help" disabled v-model="form.post_type">
              <option :value="'service location'">service location</option>
            </select>
            <span v-if="errors['post_type']" class="text-danger">{{ errors['post_type'][0] }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-12">
              <h3 class="text text-secondary">เนื้อหาในแต่ละภาษา *</h3>
              <div class="text-danger">(* จะต้องใส่ข้อมูลใน H1 และ Title สำหรับ th-TH
                ก่อนจึงจะสามารถบันทึกได้)</div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ul class="nav nav-tabs">
                <li class="nav-item" v-for="(language, langIdx) in form.languages" :key="langIdx">
                  <a class="nav-link" href="javascript:void(0);" @click="languageTabClicked(langIdx)"
                    v-bind:class="{ active: form.languages[langIdx].clicked }">
                    {{ language.name }} ({{ language.code }})

                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="row pt-1">
            <div class="col-md-12 p-4">
              <div class="tab-content">
                <div class="tab-pane" v-for="(language, langIdx) in form.languages" :key="language.id"
                  v-bind:class="{ active: form.languages[langIdx].clicked }" :id="'language_content_' + langIdx">
                  <div class="row">
                    <div class="col-md-12">
                      <p>
                        เนื้อหาในภาษา {{ language.name }} ({{ language.code }})
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Topic(H1) *</label>
                        <input default="H1" type="text" class="form-control" v-model="language.h1" />
                        <span v-if="errors['languages.' + langIdx + '.h1']" class="text-danger">{{ errors['languages.' +
                          langIdx + '.h1'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Excerpt</label>
                        <input type="text" class="form-control" v-model="language.excerpt" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>title *</label>
                        <input type="text" class="form-control" v-model="language.title" />
                        <span v-if="errors['languages.' + langIdx + '.title']" class="text-danger">{{
                          errors['languages.' + langIdx + '.title'][0] }}</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>description</label>
                        <textarea type="text" class="form-control" v-model="language.meta_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:title</label>
                        <input type="text" class="form-control" v-model="language.og_title" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:description</label>
                        <textarea type="text" class="form-control" v-model="language.og_description"></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>meta keyword</label>
                        <input type="text" class="form-control" v-model="language.meta_keyword" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:site_name</label>
                        <input type="text" class="form-control" v-model="language.og_sitename" />
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>canonical</label>
                        <input type="text" class="form-control" v-model="language.canonical" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>link_rel_alternate_hreflang</label>
                        <input type="text" class="form-control" v-model="language.link_rel_alternate_hreflang" />
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label>og:url</label>
                        <input type="text" class="form-control" v-model="language.og_url" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_width</label>
                        <input type="text" class="form-control" v-model="language.og_image_width" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_height</label>
                        <input type="text" class="form-control" v-model="language.og_image_height" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image</label>
                        <input type="text" class="form-control" v-model="language.og_image" />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group">
                        <label>og:image_type</label>
                        <input type="text" class="form-control" v-model="language.og_image_type" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:site</label>
                        <input type="text" class="form-control" v-model="language.twitter_site" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>twitter:domain</label>
                        <input type="text" class="form-control" v-model="language.twitter_domain" />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:card</label>
                        <input type="text" class="form-control" v-model="language.twitter_card" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:creator</label>
                        <input type="text" class="form-control" v-model="language.twitter_creator" />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>twitter:title</label>
                        <input type="text" class="form-control" v-model="language.twitter_title" />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label>structured data</label>
                    <textarea row="6" type="text" class="form-control" v-model="language.structured_data"></textarea>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx">
                              <a :href="'#' + 'language_part_' + partIdx" class="nav-link" @click="
                                onContentPartTabClicked(
                                  langIdx,
                                  partIdx,
                                  $event
                                )
                                " v-bind:class="{ active: contentPart.clicked }">
                                {{ partIdx === 0 ? 'ส่วนบน' : 'ส่วนล่าง' }}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="tab-content">
                            <div class="tab-pane" v-for="(
                                contentPart, partIdx
                              ) in language.language_parts" :key="partIdx"
                              v-bind:class="{ active: contentPart.clicked }">
                              <div class="row">
                                <div class="col-md-12 text text-secondary">
                                 {{ partIdx === 0 ? 'ส่วนบน' : 'ส่วนล่าง' }}
                                </div>
                              </div>

                              <div class="row">
                                <div class="col-md-12">
                                  <iframe :id="'iframe_language_' +
                                    language.id +
                                    '_part_' +
                                    partIdx
                                    " :src="'/service-location' +
                                      '/' +
                                      item_id +
                                      '/language/' +
                                      language.id +
                                      '/' +
                                      partIdx +
                                      '/' +
                                      (form.languages[langIdx].language_parts[
                                        partIdx
                                      ].content == ''
                                        ? 'n'
                                        : 'y')
                                      " height="870px" width="100%" type="application/html" frameborder="0"
                                    scrolling="no" font-family="IBM Plex Sans Thai, sans-serif"></iframe>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a href="javascript:void(0)" onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary">ยกเลิก</a>
            <button type="button" class="btn btn-primary ml-5" @click="saveWithGoBack()">
              บันทึก
            </button>
            <button type="button" v-if="!this.item_id" class="btn btn-primary ml-5" @click="saveWithMore()">
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</template>

<script>

import VueSelectImage from "vue-select-image";
require("vue-select-image/dist/vue-select-image.css");

import searchbox from "../_layouts/searchbox.vue";

export default {
  props: {
    item_id: "",
  },
  components: {
    VueSelectImage,
    searchbox,
  },
  data() {
    return {
      form: {
        desktop_cover_media_id: "",
        mobile_cover_media_id: "",
        desktop_thumbnail_id: "",
        desktop_thumbnail_url: "",
        mobile_thumbnail_id: "",
        mobile_thumbnail_url: "",
        province: "",
        district: "",
        service_image: [],

        category_id: "",
        slug: "",
        post_type: "service_location",
        comment_status: "disallow",
        status: "draft",
        faith_type: "buddist",
        languages: [
          {
            h1: "",
            canonical: "",
            excerpt: "",
            title: "",
            meta_description: "",
            og_title: "",
            og_description: "",
            meta_keyword: "",
            site_name: "",
            og_image: "",
            og_image_type: "",
            og_image_height: "",
            og_image_width: "",
            og_url: "",
            og_locale: "",
            twitter_card: "",
            twitter_creator: "",
            twitter_title: "",
            twitter_site: "",
            twitter_domain: "",
            link_rel_alternate_hreflang: "",
            structured_data: "",
            language_id: "",
            language_parts: [],
          }
        ],
      },
      validateError: {
        category_id: { error: false, message: "" },
        slug: { error: false, message: "" },
        post_type: { error: false, message: "" },
        comment_status: { error: false, message: "" },
        status: { error: false, message: "" },
        languages: { error: false, message: "" },
        thumbnail: { error: false, message: "" },
        title: { error: false, message: "" },
        h1: { error: false, message: "" },
      },
      errors: {},
      languages: [
        { title: '', h1: '' },
        { title: '', h1: '' },
        { title: '', h1: '' },
      ],
      content: "",
      editorOption: {
        modules: {
          htmlEditButton: { buttonHTML: "HTML" },
          ImageResize: { displaySize: true },
          toolbar: [
            [{ font: [] }],
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["link", "image"], // link and image
            ["blockquote", "code-block"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ["clean"], // remove formatting button
          ],
        },
        placeholder: "ใส่เนื้อหาที่นี่",
        theme: "snow",
        height: "400",
      },

      categories: {}, //เพื่อเก็บและใช้ในตัวเลือก category_id  บนฟอร์ม
      tags: [], //เพื่อเก็บและใช้ในตัวเลือก tags บนฟอร์ม
      medias: [], //thumbnail
      languages: [],

      ProductSkus: {},
      skus: [], //เพื่อเก็บและใช้ในตัวเลือก skus บนฟอร์ม

      base_url: "/cms", // base url (เปลี่ยน)

      thumbnails: [],

      desktop_thumbnail: [],
      mobile_thumbnail: [],
      thumbnails_desktop_th: [],
      thumbnails_desktop_en: [],
      thumbnails_mobile_th: [],
      thumbnails_mobile_en: [],

      banners_desktop_th: [],
      banners_desktop_en: [],
      banners_mobile_th: [],
      banners_mobile_en: [],

      service_images: [],
    };
  },
  mounted() {
    //console.log('Component mounted.')
  },
  created() {
    this.fetchLanguages();
  },
  methods: {
    load() {
      axios
        .get("/service-location/" + this.item_id)
        .then((response) => {
          let service = response.data;
          service.languages[0].media.forEach((item) => {
            this.form.service_image.push({
              id: item.id,
              url: item.url,
              mime_type: "",
            });
          });
          this.form.post_type = service.post_type;
          this.form.slug = service.slug;
          this.form.status = service.status;
          // this.form.desktop_cover_media_id = service.desktop_cover_media_id || "";
          // this.form.mobile_cover_media_id = service.mobile_cover_media_id || "";
          this.form.desktop_thumbnail_id = service.desktop_thumbnail_id || "";
          this.form.mobile_thumbnail_id = service.mobile_thumbnail_id || "";
          this.form.desktop_thumbnail_url = service.desktop_thumbnail_url || this.form.thumbnail_desktop_th;
          this.form.mobile_thumbnail_url = service.mobile_thumbnail_url || this.form.thumbnail_mobile_th;
          let slugParts = service.slug ? service.slug.split('/') : [];
          this.form.province = slugParts[0] || '';
          this.form.district = slugParts[1] || '';
          
          const lang = service.languages[0];
          this.form.languages[0].h1 = lang.h1 || lang.title;
          this.form.languages[0].canonical = lang.canonical || this.form.slug + "/";
          this.form.languages[0].excerpt = lang.excerpt || "";
          this.form.languages[0].title = lang.title;
          this.form.languages[0].meta_description = lang.meta_description || "";
          this.form.languages[0].og_title = lang.og_title || lang.title;
          this.form.languages[0].og_description = lang.og_description || lang.meta_description || "";
          this.form.languages[0].meta_keyword = lang.meta_keyword || "";
          this.form.languages[0].og_sitename = lang.og_sitename || "@wreathmala";
          this.form.languages[0].twitter_card = lang.twitter_card || "summary";
          this.form.languages[0].twitter_creator = lang.twitter_creator || "@wreathmala";
          this.form.languages[0].twitter_title = lang.twitter_title || lang.title;
          this.form.languages[0].twitter_site = lang.twitter_site || "https://www.wreathmala.com/";
          this.form.languages[0].twitter_domain = lang.twitter_domain || "https://www.wreathmala.com/";
          this.form.languages[0].header = lang.header || "";
          this.form.languages[0].og_url = lang.og_url || this.form.slug + "/";
          this.form.languages[0].og_image_height = lang.og_image_height || 630;
          this.form.languages[0].og_image_width = lang.og_image_width || 1200;
          this.form.languages[0].link_rel_alternate_hreflang = 
              lang.link_rel_alternate_hreflang || this.form.slug + "/";
          this.form.languages[0].structured_data = lang.structured_data || "";

          if (lang.language_parts[0]) {
            this.form.languages[0].language_parts[0].content = lang.language_parts[0].content;
          }

          if (lang.language_parts[1]) {
            this.form.languages[0].language_parts[1].content = lang.language_parts[1].content;
          }
        })
        .catch((errors) => {
          alert("loading Error", errors);
          console.log(errors);
        });
    },
    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";

      this.get_language_from_ifram();

      let service_image_ids = [];
      this.form.service_image.forEach((item) => {
        service_image_ids.push({ "id": item.id });
      });

      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].media = service_image_ids;
      });

      if (this.item_id != "") {
        save_url = "/service-location/" + this.item_id + "/update";
      } else {
        save_url = "/service-location/";
      }

      let me = this;

      console.log("this.form", this.form);
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log("response", response);
          response.status == "200"
            ? whatNext == "more"
              ? window.location.href = "/service-location/form"
              : window.location.href = "/service-location"
            : alert("Error Status:");
        })
        .catch((error) => {
          console.log("error.response:", error.response)
          // || error.response.status === 422
          if (error.response ) {
            this.errors = error.response.data.message;
            alert("ไม่สามารถบันทึกได้ กรุณาใส่Content หรือ อย่าใส่content ข้ามส่วนนะจ๊ะ " + this.errors);
          }
          console.log("errors:", this.errors);
        });
    },
    get_language_from_ifram() {
      let iframe = {};
      let iWindow = {};
      let iDocument = {};
      let element = {};


      this.languages.forEach((item, langIdx) => {
        for (let partIdx = 0; partIdx <= 1; partIdx++) {
          iframe = document.getElementById(
            "iframe_language_" + item.id + "_part_" + partIdx
          );
          iWindow = iframe.contentWindow;
          iDocument = iWindow.document;

          element = iDocument.getElementById("summernote_code");

          this.form.languages[langIdx].language_parts[partIdx].content =
            element.value;

        }
      });
    },
    fetchCategories(url) {
      url = url || "/cms/fetchCategories";
      axios
        .get(url)
        .then((response) => {
          this.categories = response.data.items;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;

          this.languages.forEach((item, idx) => {
            this.languages[idx].title = "";
            this.languages[idx].excerpt = "";
            this.languages[idx].tags = [];
            this.languages[idx].skus = [];
            this.languages[idx].language_parts = [
              { id: 1, content: "", skus: [], clicked: true },
              { id: 2, content: "", skus: [], clicked: false },
            ];
          });
          this.form.languages = this.languages;
          if (this.item_id) {
            this.load();
          }
        })
        .catch((errors) => {
          alert("Unable to load Languge " + errors.message);
          console.log(errors);
        });
    },
    languageTabClicked(langIdx = 0) {
      console.log("langIdx", langIdx);
      this.form.languages.forEach((item, idx) => {
        this.form.languages[idx].clicked = false;
      });
      this.form.languages[langIdx].clicked = true;
    },
    onContentPartTabClicked(langIdx, partIdx) {
      this.languageTabClicked(langIdx);

      this.form.languages[langIdx].language_parts.forEach(function (part, y) {
        if (y == partIdx) {
          part.clicked = true;
        } else {
          part.clicked = false;
        }
      });
    },
    seachDesktopThumbnail(searchKeword) {
      this.desktop_thumbnail = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          console.log("items", items);
          Object.entries(items).forEach((item, idx) => {
            this.desktop_thumbnail.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectImageDesktopThumbnail(data) {
      this.form.desktop_thumbnail_url = data.src;
      this.form.desktop_thumbnail_id = data.id;
    },
    seachMobileThumbnail(searchKeword) {
      this.mobile_thumbnail = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          console.log("mobile items", items);
          Object.entries(items).forEach((item, idx) => {
            this.mobile_thumbnail.push({
              id: item[1].id,
              src: item[1].url,
              alt: item[1].original_name,
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectImageMobileThumbnail(data) {
      this.form.mobile_thumbnail_url = data.src;
      this.form.mobile_thumbnail_id = data.id;
    },
    onSelectServiceImage(data) {
      const exists = this.form.service_image.some(image => image.id === data.id);
      if (!exists) {
        this.form.service_image.push({
          id: data.id,
          url: data.src,
          alt: data.original_name,
        });
      } else {
        alert("Image already exists in the list.");
      }
    },
    removeServiceImage(index) {
      let temp = this.form.service_image;
      this.form.service_image.splice(index, 1);
      this.form.service_image = this.form.service_image.map((item, idx) => {
        return {
          ...item,
        };
      });
    },
  },
};
</script>
<style scoped>
.ql-editor {
  max-height: 300px !important;
  min-height: 300px !important;
  overflow: auto;
}

#language_content_0 {
  background-color: #b0c4de;
  /* Active background color */
  color: black;
  padding: 20px;
}

#language_content_1 {
  background-color: #faebd7;
  /* Active background color */
  color: black;
  padding: 20px;
}
</style>